import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { getWppftDetails, getDistrict, getBlockByDistrict, getVillageByBlock } from '../../api/User';
import { ToastContainer, toast } from "react-toastify";
import "./table.css"
const WPPFTAdmin = () => {
  const role_id = sessionStorage.getItem("role_id");
  const token = sessionStorage.getItem("token") || "";
  const gpID = (sessionStorage.getItem("gp_data") == 1 ? "all" : sessionStorage.getItem("gp_data")) || "";
  const userId = sessionStorage.getItem("user_id");
  const [formData, setFormData] = useState({
    user_id: userId,
    designation: "",
    mobile_no: "",
    full_name: "",
    email: "",
    entity_name: "",
    entity_type: "",
  });
  const [errors, setErrors] = useState({});
  const [district, setDistrict] = useState([]);
  const [selectedDistrictCode, setSelectedDistrictCode] = useState('');
  const [selectedDistrictName, setSelectedDistrictName] = useState('');
  const [selectedBlockCode, setSelectedBlockCode] = useState('');
  const [selectedBlockName, setSelectedBlockName] = useState('');
  const [selectedVillage, setSelectedVillage] = useState('');
  const [block, setBlock] = useState([]);
  const [village, setVillage] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const navigate = useNavigate();
  const fetchData = async () => {
    const data = {
      role_id: role_id,
      id: userId,
      gp_data_id: gpID
    }
    try {
      const res = await getWppftDetails(token, data);
      if (res.status === "success") {
        setFilteredData(res.data);
      } else {
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("An error occurred while fetching data.", { autoClose: 1000 });
    }
  };
  const fetchDistrict = async () => {
    try {
      const res = await getDistrict(token);
      if (res.status === 'success') {
        setDistrict(res.data);
      } else {
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error('Error fetching district data:', error);
      toast.error('An error occurred while fetching district data.', { autoClose: 1000 });
    }
  };
  const fetchBlockByDistrict = async (districtCode) => {
    try {
      const res = await getBlockByDistrict(token, districtCode);
      if (res.status === 'success') {
        setBlock(res.data);
      } else {
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error('Error fetching block data:', error);
      toast.error('An error occurred while fetching block data.', { autoClose: 1000 });
    }
  };
  const fetchVillageByBlock = async (districtCode, blockCode) => {
    try {
      const res = await getVillageByBlock(token, districtCode, blockCode);
      if (res.status === 'success') {
        setVillage(res.data);
      } else {
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error('Error fetching village data:', error);
      toast.error('An error occurred while fetching village data.', { autoClose: 1000 });
    }
  };
  const handleDistrictChange = (event) => {
    const selectedCode = event.target.value;
    const selectedDistrict = district.find(item => item.district_code === selectedCode);
    setSelectedDistrictCode(selectedCode);
    setSelectedBlockCode('');
    setSelectedVillage('');
    setBlock([]);
    setVillage([]);
    if (selectedCode) {
      fetchBlockByDistrict(selectedCode);
    }
    if (selectedDistrict) {
      setSelectedDistrictName(selectedDistrict.district_name);
    }
  };
  const handleBlockChange = (event) => {
    const selectedCode = event.target.value;
    const selectedBlock = block.find(item => item.block_code === selectedCode);
    setSelectedBlockCode(selectedCode);
    setSelectedVillage('');
    setVillage([]);
    if (selectedCode) {
      fetchVillageByBlock(selectedDistrictCode, selectedCode);
    }
    if (selectedBlock) {
      setSelectedBlockName(selectedBlock.block_name);
    }
  };
  const handleVillageChange = (event) => {
    const selectedCode = event.target.value;
    setSelectedVillage(selectedCode);
  };
  useEffect(() => {
    fetchData();
    fetchDistrict();
  }, []);
  const filteredRecords = filteredData
    .filter((row) => {
      const districtMatch = !selectedDistrictCode || row.district === selectedDistrictName;
      const blockMatch = !selectedBlockCode || row.block === selectedBlockName;
      const villageMatch = !selectedVillage || row.gram_panchayat === selectedVillage;
      return districtMatch || blockMatch || villageMatch;
    });
  return (
    <>
      <div className="container-fluid" style={{ height: "91vh" }}>
        <div>
        </div>
        <div className="container-fluid mt-3">
          <div className="d-flex align-items-center justify-content-between">
            <h2 className="mb-0">Ward Panchayat Planning Formulation Team (WPPFT)</h2>
          </div>
        </div>
        <div style={{ overflowX: "auto", maxHeight: "70%", marginTop: "20px" }}>
          <div className="container-fluid mt-3">
            <div className="sticky-top bg-white py-2">
              <div className="d-flex align-items-center justify-content-between">
                <h4 className="mb-0">Resource List</h4>
                <div className="d-flex">
                  <div className="me-3">
                    <select
                      className="form-select dropdown-custom"
                      value={selectedDistrictCode}
                      onChange={handleDistrictChange}
                    >
                      <option value="" disabled>Select District</option>
                      {district.map((item) => (
                        <option key={item.district_code} value={item.district_code}>
                          {item.district}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="me-3">
                    <select
                      className="form-select dropdown-custom"
                      value={selectedBlockCode}
                      onChange={handleBlockChange}
                    >
                      <option value="" disabled>Select Block</option>
                      {block.map((item) => (
                        <option key={item.block_code} value={item.block_code}>
                          {item.block}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="me-3">
                    <select
                      className="form-select dropdown-custom"
                      value={selectedVillage}
                      onChange={handleVillageChange}
                    >
                      <option value="" disabled>Select Gram Panchayat</option>
                      {village.map((item) => (
                        <option key={item.village_code} value={item.village_code}>
                          {item.gram_panchayat}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className="table-responsive mt-3">
              <table className="table">
                <hr style={{ margin: '20px 0', border: '2px solid #ddd' }} />
                <Table aria-label="simple table">
                  <TableHead
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 1,
                      backgroundColor: "#fff",
                    }}
                  >
                    <TableRow>
                      <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">SR NO.</TableCell>
                      <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">FULL NAME</TableCell>
                      <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">MOBILE NUMBER</TableCell>
                      <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">EMAIL ID</TableCell>
                      <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">DESIGNATION</TableCell>
                      <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                        ENTITY TYPE
                      </TableCell>
                      <TableCell
                        style={{ whiteSpace: "nowrap", fontWeight: "bold" }}
                        align="center"
                        colSpan={3}
                      >
                        ENTITY NAME
                        <TableRow>
                          <TableCell
                            style={{ whiteSpace: "nowrap", fontWeight: "bold" }}
                            align="center"
                          >
                            DISTRICT NAME
                          </TableCell>
                          <TableCell
                            style={{ whiteSpace: "nowrap", fontWeight: "bold" }}
                            align="center"
                          >
                            BLOCK NAME
                          </TableCell>
                          <TableCell
                            style={{ whiteSpace: "nowrap", fontWeight: "bold" }}
                            align="center"
                          >
                            GRAM PANCHAYAT NAME
                          </TableCell>
                        </TableRow>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filteredRecords.map((row, index) => (
                      <TableRow key={row.id}>
                        <TableCell style={{ whiteSpace: "nowrap" }} align="center">
                          {index + 1}
                        </TableCell>
                        <TableCell style={{ whiteSpace: "nowrap" }} align="center">
                          {row.full_name}
                        </TableCell>
                        <TableCell style={{ whiteSpace: "nowrap" }} align="center">
                          {row.mobile_no}
                        </TableCell>
                        <TableCell style={{ whiteSpace: "nowrap" }} align="center">
                          {row.email}
                        </TableCell>
                        <TableCell style={{ whiteSpace: "nowrap" }} align="center" className="custom-class">
                          {row.designation}
                        </TableCell>
                        <TableCell style={{ whiteSpace: "nowrap" }} align="center">
                          {row.entity_type}
                        </TableCell>
                        <TableCell style={{ whiteSpace: 'nowrap' }} align="center">
                          {row.district !== null && row.district !== undefined ? row.district : '----------'}
                        </TableCell>
                        <TableCell style={{ whiteSpace: 'nowrap' }} align="center">
                          {row.block !== null && row.block !== undefined ? row.block : '----------'}
                        </TableCell>
                        <TableCell style={{ whiteSpace: 'nowrap' }} align="center">
                          {row.gram_panchayat !== null && row.gram_panchayat !== undefined ? row.gram_panchayat : '----------'}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </table>
            </div>
          </div>
        </div>
        <ToastContainer />
      </div></>
  );
};
export default WPPFTAdmin;
